module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5NjAiIGhlaWdodD0iNDgwIiB2aWV3Qm94PSIwIDAgOTYgNDgiPjxnIGZpbGw9IiNDMTAwMDAiPjxwYXRoIGQ9Ik0wIDBoOTZ2NDhIMHoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDQwdjI0SDB6Ii8+PHBhdGggZD0iTTE3IDNoNnYxOGgtNnoiLz48cGF0aCBkPSJNMTEgOWgxOHY2SDExeiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ton.svg
// module id = wztd
// module chunks = 0